import deepmerge from 'deepmerge';

import { AppConfig } from '../app-config';
import developmentConfig from './development';

const trainingConfig = deepmerge<AppConfig>(developmentConfig, {
  baseApiPath: 'https://api-training.bh-demo.com/',
  apmUrl: 'https://apm-training.bh-demo.com',
  apmEnv: 'development',
  auth0: {
    domain: 'iam-training.bh-demo.com',
    clientId: 'Mg5hGPqZdqpVXm3id8RynAPX1jyp0CJT',
    audience: 'https://api-training.bh-demo.com',
  },
  keycloak: {
    enabled: true,
    authority: 'https://auth.bh-staging.com/realms/training',
    clientId: 'member-portal',
  },
  streamChatAppId: 'h4cxywna2g7a',
  streamChatDisable: false,
  stripeKey:
    'pk_test_51JjNzpFEZYlgNqDIlT9801p31tifytbne53X6CeL1uSL13APa0Fah478jyqmqK4AKUN4Lyq3P7t8JXaxBtcr9d00007nOiO1xW',
  stripePackages: {
    // C3
    PsychLed: {
      title: 'Coaching, Therapy & Medication',
      subtitle: '',
      offerText: '',
      price: '219.99',
      timeframe: 'per month',
      stripePriceId: 'price_1LG7dqFEZYlgNqDIxlHKReLW',
    },
    // C2
    CoachingAndTherapy: {
      title: 'Coaching + Therapy',
      subtitle: '',
      offerText: '',
      price: '159.99',
      timeframe: 'per month',
      stripePriceId: 'price_1JmT9HFEZYlgNqDIcE2MbPfz',
    },
    // C1
    CoachingOnly: {
      title: 'Coaching',
      subtitle: '',
      offerText: '',
      price: '79.99',
      timeframe: 'per month',
      stripePriceId: 'price_1LG7d4FEZYlgNqDIHa0nNkLi',
    },
  },
  stripePackagesOneOneTwentyThree: {
    // C3
    PsychLed: {
      title: 'Coaching, Therapy & Medication',
      subtitle: '',
      offerText: '',
      price: '549.99',
      timeframe: 'per month',
      stripePriceId: 'price_1MKvWlFEZYlgNqDIVcUPYjxd',
    },
    // C2
    CoachingAndTherapy: {
      title: 'Coaching + Therapy',
      subtitle: '',
      offerText: '',
      price: '399.99',
      timeframe: 'per month',
      stripePriceId: 'price_1MKvWHFEZYlgNqDIKuuGQHbB',
    },
    // C1
    CoachingOnly: {
      title: 'Coaching',
      subtitle: '',
      offerText: '',
      price: '199.99',
      timeframe: 'per month',
      stripePriceId: 'price_1MKvV6FEZYlgNqDIoU0GDLTf',
    },
  },
  launchDarklyKey: '6270048f52e5c715abd12d77',
  launchDarklyDisable: false,
});

export default trainingConfig;
